import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchStrategy } from 'assets/js/pages/reports/fetchStrategy';
import { queryKeyStrategy } from 'assets/js/pages/reports/queryKeyStrategy';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentReport } from 'customHooks/useCurrentReport';
import { PaginatedData } from 'types/pagination';

const useFetchReportMeta = () => {
    const { accountId } = useCurrentAccount();
    const { data: report } = useCurrentReport();
    const params = {
        page: 1,
        filters: report.query.filters,
    };
    return useSuspenseQuery<PaginatedData<unknown>>({
        queryKey: queryKeyStrategy(report.resource)(accountId, params),
        queryFn: () => fetchStrategy(report.resource)(accountId, params),
    });
};

export { useFetchReportMeta };
